import { createContext, use, useEffect, useState } from 'react';
import { useOfflineSync } from '@/lib/hooks/use-offline-sync';
import { sortOutlines } from './outline-data-service';
import { DBCollection } from '@/lib/utils/constants-shared';
import { AppDataContext } from '@/lib/app-data-hydration';
import { DBContext } from '@/lib/context';
import { DataCacheService } from '@/lib/utils/data-cache-service';

type ItemType = Outline;
const collection = DBCollection.outlines;

export const OutlineDataContext = createContext<DataContext<ItemType>>(undefined);

export function OutlineDataProvider({ children }) {
    const db = use(DBContext);
    const {data: allData} = use(AppDataContext);
    const {markForSync, resolveSync} = useOfflineSync();
    const [data, setData] = useState<ItemData<ItemType>>();
    const service = new DataCacheService<ItemData<ItemType>>(db, collection, markForSync, resolveSync, data, setData, sortOutlines, []);

    useEffect(() => {
        service.setNewItems(allData?.outlines);
    }, [allData?.outlines]);

    return <OutlineDataContext value={{
        add: item => service.add(item),
        data,
        get: id => service.get(id),
        remove: id => service.remove(id),
        update: partial => service.update(partial),
        updateAll: items => service.updateAll(items)
    }}>
        {children}
    </OutlineDataContext>;
}